import React from "react";
import LegalPageLayout, { LEGAL_OWNER } from "./LegalPageLayout";

export default function PrivacyCookiesPage() {
  return (
    <LegalPageLayout
      title="Política de privacidad y cookies"
      subtitle="Cómo tratamos tus datos personales y cómo usamos cookies."
      updatedAt="18 de febrero de 2026"
    >
      <section className="panel">
        <h2 className="panel-title">Responsable del tratamiento</h2>
        <p>
          Responsable: {LEGAL_OWNER.legalName}. Contacto legal para privacidad: {LEGAL_OWNER.email}.
        </p>
        <p>
          No existe delegado de protección de datos designado por no concurrir los supuestos de obligatoriedad del artículo 37 RGPD
          y la normativa española aplicable.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Datos que tratamos</h2>
        <p>
          Tratamos datos identificativos y de cuenta (email y credenciales cifradas), datos técnicos de uso de la plataforma,
          datos de facturación y datos financieros que la persona usuaria importa de forma voluntaria (movimientos, categorías,
          cuentas, tarjetas y presupuestos).
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Finalidades y bases jurídicas</h2>
        <p>
          1) Alta, autenticación y gestión de cuenta (ejecución de contrato). 2) Prestación del servicio de análisis y organización
          financiera (ejecución de contrato). 3) Gestión de pagos, suscripción y facturación (ejecución de contrato y obligaciones
          legales). 4) Seguridad, prevención de abuso y soporte técnico (interés legítimo). 5) Comunicaciones operativas o legales
          esenciales del servicio (interés legítimo y, en su caso, obligación legal).
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Conservación de datos</h2>
        <p>
          Conservamos los datos mientras exista cuenta activa o relación contractual. Tras la baja, se conservarán bloqueados durante
          los plazos exigidos por normativa fiscal, mercantil y de defensa frente a reclamaciones. Puedes solicitar borrado total de
          datos desde tu área privada, sin perjuicio de las obligaciones legales de conservación que resulten aplicables.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Conservación, destinatarios y transferencias</h2>
        <p>
          Podemos usar proveedores tecnológicos (hosting, email transaccional, autenticación social y pasarela de pago) que actúan
          como encargados de tratamiento. Cuando un proveedor esté fuera del EEE o sujeto a transferencias internacionales, se
          aplicarán garantías adecuadas conforme al RGPD (por ejemplo, cláusulas contractuales tipo u otros mecanismos válidos).
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Derechos del usuario</h2>
        <p>
          Puedes ejercer los derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a{" "}
          {LEGAL_OWNER.email}. También puedes retirar tu consentimiento cuando el tratamiento se base en él y presentar reclamación
          ante la Agencia Española de Protección de Datos (AEPD).
        </p>
        <p>
          Para proteger tu privacidad, podremos pedir verificación razonable de identidad antes de atender la solicitud.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Decisiones automatizadas y perfiles</h2>
        <p>
          No se adoptan decisiones automatizadas con efectos jurídicos sobre las personas usuarias ni se elaboran perfiles
          automatizados para fines publicitarios.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Política de cookies y tecnologías similares</h2>
        <p>
          Actualmente usamos tecnologías técnicas/necesarias para el funcionamiento y seguridad del servicio. No activamos cookies
          analíticas o publicitarias no necesarias por defecto.
        </p>
        <p>
          En el cliente web se almacena una preferencia técnica de consentimiento en almacenamiento local del navegador
          (`ary_cookie_consent_v1`) para recordar tu elección. Esta información permanece hasta que la elimines manualmente o
          borres los datos del navegador.
        </p>
        <p>
          Puedes gestionar tus preferencias desde el panel de cookies de la web y, adicionalmente, eliminar almacenamiento/cookies
          desde la configuración de tu navegador.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Personas menores de edad</h2>
        <p>
          El servicio no está dirigido de forma específica a menores. Si detectas uso de la plataforma por una persona menor sin
          autorización válida, contacta en {LEGAL_OWNER.email} para revisar y, en su caso, suprimir los datos.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Cambios de esta política</h2>
        <p>
          Podemos actualizar esta política para reflejar cambios normativos o funcionales del servicio. Publicaremos la fecha de
          actualización en esta misma página.
        </p>
      </section>
    </LegalPageLayout>
  );
}
